import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M7.89.546a.75.75 0 0 1 .818.162l3.559 3.559a.75.75 0 0 1-.027 1.086L9.315 8l2.925 2.647a.75.75 0 0 1 .027 1.086l-3.559 3.559a.75.75 0 0 1-1.28-.53V9.707l-2.662 2.408a.75.75 0 0 1-1.006-1.112L7.08 8 3.76 4.997a.75.75 0 1 1 1.006-1.112l2.662 2.408V1.238A.75.75 0 0 1 7.89.546Zm1.038 9.127 1.72 1.557-1.72 1.72V9.674Zm0-3.346V3.049l1.72 1.721-1.72 1.557Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function c(a, d) {
  return e(), t("svg", l, [...r]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
